import { afterNextRender, Directive, ElementRef, inject, input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dynamicUrl]',
  standalone: true,
})
export class DynamicUrlDirective {
  readonly routerLink = input.required<string>();
  readonly #renderer = inject(Renderer2);
  readonly #el = inject<ElementRef<Element>>(ElementRef);

  constructor() {
    afterNextRender(() => {
      const routerLink = this.routerLink();
      if (routerLink?.startsWith('http')) {
        const link = this.#renderer.createElement('a') as HTMLLinkElement;
        link.setAttribute('href', routerLink);
        link.setAttribute('target', '_blank');
        link.setAttribute('class', 'link');
        const style = this.#el.nativeElement.getAttribute('style');
        if (style) {
          link.setAttribute('style', style);
        }
        link.innerHTML = this.#el.nativeElement.innerHTML;
        this.#el.nativeElement.replaceWith(link);
      }
    });
  }
}
